import { useState } from 'react';
import { useMeasure } from 'react-use';
import Empty from '../Empty/Empty';
import LoaderPage from '../LoaderPage/LoaderPage';
import ModelCard, { IModel } from '../ModelCard/ModelCard';
import ModelPreview from '../ModelPreview/ModelPreview';
import { useDimensions } from '../VirtualGallery/VirtualGallery.hooks';
import styles from './ModelGallery.module.css';
import { Wrapper } from './ModelGallery.style';

export type ModelGalleryProps = {
  items: IModel[];
  baseImageUrl: string;
  cols?: number;
  personal?: boolean;
  isLoading?: boolean;
  onClick?: (model: IModel) => void;
  containImage?: boolean;
};

// divide window width to 250

export function ModelGallery(props: ModelGalleryProps) {
  const { items = [], baseImageUrl, personal, isLoading, containImage } = props;
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const { columnCount: cols } = useDimensions(width, false);
  const [currentItem, setCurrentItem] = useState<IModel | null>(null);

  if (!cols) {
    return (
      <Wrapper
        className='ModelGallery-wrapper'
        data-testid='ModelGallery-wrapper'
        ref={ref}
      ></Wrapper>
    );
  }
  // Split items into five columns
  const columns = Array.from({ length: cols }, () => []) as IModel[][];

  items.forEach((item, index) => {
    columns[index % cols].push(item);
  });

  function onClick(item: IModel) {
    if (props.onClick) {
      props.onClick(item);
      return;
    }

    setCurrentItem(item);
  }

  if (isLoading) {
    return <LoaderPage />;
  }

  if (items.length === 0) {
    return <Empty>Empty list</Empty>;
  }

  return (
    <Wrapper className='ModelGallery-wrapper' data-testid='ModelGallery-wrapper' ref={ref}>
      <div className={styles.masonry}>
        {columns.map((column, colIndex) => (
          <div key={colIndex} className={styles.masonryColumn}>
            {column.map((item, index) => (
              <ModelCard
                key={`${colIndex}-${index}`}
                model={item}
                baseImageUrl={baseImageUrl}
                onClick={() => onClick(item)}
                personal={personal}
                containImage={containImage}
                noClick={typeof props.onClick !== 'function'}
              />
            ))}
          </div>
        ))}
      </div>
      {currentItem && <ModelPreview model={currentItem} onClose={() => setCurrentItem(null)} />}
    </Wrapper>
  );
}

export default ModelGallery;
